import { Axios } from "services/axios";

export const categoriesApi = {
  fetchAllActiveCategoriesOptimized: async (options = {}) => {
    try {
      const {
        page = 1,
        limit = 30,
        featuresLimit = 15
      } = options;

      console.log("Fetching optimized categories from API...");
      
      const params = new URLSearchParams({
        page: String(page),
        limit: String(limit),
        featuresLimit: String(featuresLimit)
      });

      const response = await Axios.fetch(`/shop/getAllActiveCategoriesOptimized?${params}`);
      
      if (!response || !response.data) {
        throw new Error('Invalid response structure from server');
      }

      const responseData = response.data.data || response.data || {};
      
      if (!responseData.categories || !Array.isArray(responseData.categories)) {
        throw new Error('Categories data is not in expected format');
      }

      console.log("Optimized categories fetched successfully:", responseData);
      return responseData; // Returns { categories, featuresData, pagination, meta }

    } catch (error) {
      console.error('Error fetching optimized categories:', error);
      
      let errorMessage = 'Failed to fetch categories';
      
      if (error.response) {
        errorMessage = error.response.data?.message || 
                     `Server error: ${error.response.status}`;
      } else if (error.request) {
        errorMessage = 'Network error: Unable to reach server';
      } else {
        errorMessage = error.message || errorMessage;
      }
      
      throw new Error(errorMessage);
    }
  },
  
  fetchAllActiveCategories: async () => {
    try {
      const response = await Axios.fetch('/shop/getAllActiveCategories');
      
      if (!response || !response.data) {
        throw new Error('Invalid response structure from server');
      }

      const categories = response.data.data || response.data || [];
      
      if (!Array.isArray(categories)) {
        throw new Error('Categories data is not in expected format');
      }

      return categories;
    } catch (error) {
      console.error('Error fetching categories:', error);
      
      // Handle different types of errors
      let errorMessage = 'Failed to fetch categories';
      
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        errorMessage = error.response.data?.message || 
                     `Server error: ${error.response.status}`;
      } else if (error.request) {
        errorMessage = 'Network error: Unable to reach server';
      } else {
        // Something happened in setting up the request that triggered an Error
        errorMessage = error.message || errorMessage;
      }
      
      throw new Error(errorMessage);
    }
  },

  fetchCategoryById: async (id) => {
    try {
      if (!id) {
        throw new Error('Category ID is required');
      }

      const response = await Axios.fetch(`/shop/getCategoryById/${id}`);
      
      // Validate response structure
      if (!response || !response.data) {
        throw new Error('Invalid response structure from server');
      }

      // Extract category data
      const category = response.data.data || response.data;
      
      if (!category) {
        throw new Error('Category not found');
      }

      return category; 
    } catch (error) {
      console.error('Error fetching category:', error);
      
      let errorMessage = 'Failed to fetch category';
      
      if (error.response) {
        if (error.response.status === 404) {
          errorMessage = 'Category not found';
        } else {
          errorMessage = error.response.data?.message || 
                        `Server error: ${error.response.status}`;
        }
      } else if (error.request) {
        errorMessage = 'Network error: Unable to reach server';
      } else {
        errorMessage = error.message || errorMessage;
      }
      
      throw new Error(errorMessage);
    }
  },

  refreshCategories: async () => {
    try {
      // console.log("Refreshing categories cache...");
      return await categoriesApi.fetchAllCategories();
    } catch (error) {
      console.error('Error refreshing categories:', error);
      throw error;
    }
  }
};
